// import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
// import React, { useContext, useEffect, useState } from 'react'
// // import TopHeader from '../../../../components/general/TopHeader';
// import { Nav, Tab, Tabs } from 'react-bootstrap';
// import { PvMonitoringContext } from '../../../../context/PvMonitoringContext';
// import PvParameterTabContent from '../pv_monitoring/pv_monitoring_tabs/pv_parameter/pv_parameter_tabs/PvParameterTabContent';
// import { WEB_KEY, PASS_KEY } from '../../../../api/AxiosApi';
// import TopHeader from '../../../../components/general/TopHeader';
// import Loading from '../../../../components/loading/Loading';
// import DataNotFound from '../../../../components/error/DataNotFound';
// import BatteryTabs from './BatterTabs/BatteryTabs';

// export default function Battery() {
//     const { palette, typography, breakpoints, spacing } = useTheme()
//     const matches = useMediaQuery(breakpoints.up('lg'));
//     const { getPvMnMenu_INV, PvMnMenuData_INV, Pv_MnMenu_INV_Loading } = useContext(PvMonitoringContext)
//     const LOGIN_ID = localStorage.getItem('LoginID')
//     const LOC_CODE = localStorage.getItem('LCODE')
//     const TYE = "Y"
//     const [key, setKey] = useState('');

//     console.log("lcode",LOC_CODE)

//     useEffect(() => {
//         if (PvMnMenuData_INV && PvMnMenuData_INV?.length > 0) {
//             setKey(PvMnMenuData_INV[0]?.FEEDER_ID);
//         }
//     }, [PvMnMenuData_INV]);

//     useEffect(() => {
//         getPvMnMenu_INV(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYE)
//     }, [LOGIN_ID])

//     return (
//         <>
//             <CssBaseline />
//             <TopHeader />
//             <Box py={spacing(1)} bgcolor={'background.default'}>
//                 {
//                     Pv_MnMenu_INV_Loading ? <Loading /> :
//                         PvMnMenuData_INV?.length <= 0 ?
//                             <DataNotFound /> :
//                             <Tabs
//                                 style={{ justifyContent: "flex-end", }}
//                                 id="controlled-tab-example"
//                                 activeKey={key}
//                                 onSelect={(k) => setKey(k)}
//                             >
//                                 {

//                                     PvMnMenuData_INV?.map((item, index) => {
//                                         return (
//                                             <Tab key={index} eventKey={item?.FEEDER_ID} title={item?.NAME}>
//                                                 <BatteryTabs TabTitle={item?.NAME} ID={key} />
//                                             </Tab>
//                                         )
//                                     })


//                                 }


//                             </Tabs>




//                 }


//             </Box>
//         </>

//     )
// }


import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
// import TopHeader from '../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { PvMonitoringContext } from '../../../../context/PvMonitoringContext';
import PvParameterTabContent from '../pv_monitoring/pv_monitoring_tabs/pv_parameter/pv_parameter_tabs/PvParameterTabContent';
import { WEB_KEY, PASS_KEY } from '../../../../api/AxiosApi';
import TopHeader from '../../../../components/general/TopHeader';
import Loading from '../../../../components/loading/Loading';
import DataNotFound from '../../../../components/error/DataNotFound';
import BatteryTabs from './BatterTabs/BatteryTabs';
import TotalBatteryPower from './totalBatteryPower/TotalBatteryPower';



export default function Battery() {
  const { palette, typography, breakpoints, spacing } = useTheme();
  const matches = useMediaQuery(breakpoints.up("lg"));

  const { getPvMnMenu_INV, PvMnMenuData_INV, Pv_MnMenu_INV_Loading } =
    useContext(PvMonitoringContext);

  const LOGIN_ID = sessionStorage.getItem("LoginID");
  const LOC_CODE = sessionStorage.getItem("LCODE");
  const TYE = "Y";

  const [key, setKey] = useState("Total Battery Power");

  useEffect(() => {
    if (PvMnMenuData_INV && PvMnMenuData_INV.length > 0) {
      setKey(PvMnMenuData_INV[0]?.FEEDER_ID);
    }
  }, [PvMnMenuData_INV]);

  useEffect(() => {
    getPvMnMenu_INV(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYE);
  }, [LOGIN_ID, LOC_CODE]); // include LOC_CODE as dependency

  return (
    <>
      <CssBaseline />
      <TopHeader />
      <Box py={spacing(1)} bgcolor={"background.default"}>
        {Pv_MnMenu_INV_Loading ? (
          <Loading />
        ) : PvMnMenuData_INV?.length <= 0 ? (
          <DataNotFound />
        ) : (
          <Tabs
          style={{ justifyContent: "flex-end", }}
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            {/* Static "Total Battery Power" tab */}
            <Tab eventKey="Total Battery Power" title="Total Battery Power">
             <TotalBatteryPower/>
            </Tab>

            {/* Dynamic tabs from API data */}
            {PvMnMenuData_INV.map((item, index) => (
              <Tab key={index} eventKey={item?.FEEDER_ID} title={item?.NAME}>
                <BatteryTabs TabTitle={item?.NAME} ID={item?.FEEDER_ID} />
              </Tab>
            ))}
          </Tabs>
        )}
      </Box>
    </>
  );
}
